import React, { useEffect, useState } from 'react';
import { Alert, Spin } from 'antd';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import AdminUserProfileEditor from './AdminUserProfileEditor';

const AdminUserProfilePage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchUser = async () => {
      try {
        setLoading(true);
        setError('');
        const res = await axios.get(`https://app-swingervip-production.up.railway.app/api/user/${id}`);
        setUser(res.data);
      } catch (err) {
        console.error('Error al cargar usuario para editar perfil:', err);
        setError('No se pudo cargar el usuario.');
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchUser();
    }
  }, [id]);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: 60 }}>
        <Spin size="large" />
      </div>
    );
  }

  if (error || !user) {
    return (
      <div style={{ padding: 24 }}>
        <Alert
          type="error"
          message={error || 'No se encontró el usuario.'}
          showIcon
        />
      </div>
    );
  }

  return (
    <AdminUserProfileEditor
      user={user}
      onClose={() => navigate('/admin/users')}
      onSuccess={(updatedUser) => {
        setUser(updatedUser);
      }}
    />
  );
};

export default AdminUserProfilePage;
